import {
  fetchSlAccounts as fetchSlAccountsApi,
  fetchAccountBalances as fetchAccountBalancesApi,
} from '../../api';
import { fetchingError } from '../../../shared/store/actions';
import { errorNotification } from '../../../shared/store/notificationActions';

import {
  FETCH_ACCOUNT_BALANCES,
  FETCH_ACCOUNT_BALANCES_SUCCESS,
  FETCH_ACCOUNT_BALANCES_FAILURE,
  FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES,
  FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_SUCCESS,
  FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_FAILURE,
  SELECT_SL_ACCOUNTS,
} from './types';


export const fetchAccountBalances = ({ periodName, displayBy }) => async dispatch => {
  try {
    dispatch({ type: FETCH_ACCOUNT_BALANCES });

    const accountBalances = await fetchAccountBalancesApi({ periodName, displayBy });

    return dispatch({
      type: FETCH_ACCOUNT_BALANCES_SUCCESS,
      accountBalances,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ACCOUNT_BALANCES_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }

    throw error;
  }
};

export const fetchSlAccounts = periodName => async dispatch => {
  try {
    dispatch({ type: FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES });

    const slAccounts = await fetchSlAccountsApi({ periodName });

    return dispatch({
      type: FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_SUCCESS,
      slAccounts,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }

    throw error;
  }
};

export const selectSlAccounts = accounts => ({
  type: SELECT_SL_ACCOUNTS,
  selectedSlAccounts: accounts,
});
